import * as React from 'react';
import ReactModal, { type Classes } from 'react-modal';
import styled from 'styled-components';
import { BREAKPOINTS } from '@/shared/modules/styled-system';
interface ReactModalProps {
  isOpen: boolean;
  onRequestClose?: () => void;
  className?: string;
  onAfterOpen?: () => void;
  onAfterClose?: () => void;
  modalClassName?: Classes;
  adaptiveModal?: boolean;
  shouldCloseOnOverlayClick?: boolean;
  closeTimeoutMS?: number;
}
interface StyledModalProps {
  isBgColor?: boolean;
  fadeOut?: boolean;
  isHeaderAbove?: boolean;
  bgImage?: string;
  borderRValue?: number;
  topPosition?: number;
}
const ReactModalAdapter = ({
  className,
  modalClassName,
  ...props
}: React.PropsWithChildren<ReactModalProps>) => <ReactModal className={modalClassName} portalClassName={className} {...props} data-sentry-element="ReactModal" data-sentry-component="ReactModalAdapter" data-sentry-source-file="modal.styled.tsx" />;
export const Modal = styled(ReactModalAdapter).attrs({
  overlayClassName: {
    base: 'Overlay',
    afterOpen: 'OverlayAfter',
    beforeClose: 'OverlayBefore'
  },
  modalClassName: {
    base: 'Modal',
    afterOpen: 'ModalAfter',
    beforeClose: 'ModalBefore'
  }
})<StyledModalProps>`
  .Overlay {
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    position: fixed;
    opacity: 0;
    transition: opacity 0.3s;

    @media ${BREAKPOINTS.DESKTOP} {
      overflow-y: auto;
      padding: 20px;
      display: flex;
      align-items: flex-start;
    }
  }

  .OverlayAfter {
    opacity: 1;
    overflow-y: auto;
  }

  .OverlayBefore {
    opacity: 0;
  }

  .Modal {
    position: relative;
    margin: '20vh auto 1rem';
    border-radius: 4px;
    overflow: hidden;
    transition:
      opacity 0.3s,
      transform 0.3s;
    transform: translateY(20px);
  }

  .ModalAfter {
    transform: translateY(0);
  }

  .ModalBefore {
    transform: translateY(20px);
  }
`;